import { useTranslation } from "react-i18next";

import styled from "@emotion/styled";

import { CyberSecurityListItem } from "../../../../models/CybersecurityObject";
import { useActions } from "../../../../hooks/useActions";
import { useTypedSelector } from "../../../../hooks/useTypedSelector";
import useMobileScreen from "../../../../hooks/useMobileScreen";
import { breakpoints } from "../../../../constants";
import {
  ListViewHeaderCell,
  ListViewHeaderIconSpacer,
  ListViewHeaderRow,
  ListViewStickyHeader,
} from "../../../../share/searchResults";
import SearchResultsResponsive from "../../../../share/searchResults/SearchResultsResponsive";
import CybersecuritySearchResultItem from "./CybersecuritySearchResultItem";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type categoriesKeys =
  | "services_cb"
  | "integrators"
  | "vendors"
  | "distributors"
  | "training_cb"
  | "startup"
  | "association"
  | "ethical_hacking"
  | "mssp"
  | "audit_consulting"
  | "has_certifications"
  | "has_other_services";

const CybersecurityMapSearchResults = () => {
  const {
    setCleanAllCybersecurityFilters,
    getCybersecurityList: getDefaultCybersecurityResult,
    refreshFeedForCybersecuritySearchResults,
  } = useActions();
  const cyberSecurityData = useTypedSelector(
    (state) => state.mapCybersecurityInfo
  );
  const count = cyberSecurityData.count;

  const cybersecurity_dataset = cyberSecurityData.results;
  const { isListViewActive } = useTypedSelector((state) => state.mapInterface);
  const isMobile = useMobileScreen(breakpoints.small);
  const shouldRenderHeader =
    isListViewActive &&
    !isMobile &&
    Boolean(cybersecurity_dataset && cybersecurity_dataset.length > 0);

  const { t } = useTranslation("translation", {
    keyPrefix: "mainPage.mapFilters.listView.headers.cybersecurity",
  });
  const handleClean = () => {
    setCleanAllCybersecurityFilters();
    getDefaultCybersecurityResult();
  };

  return (
    <SearchResultsResponsive
      onClearAllFilters={handleClean}
      count={count}
      handleLoadFeed={refreshFeedForCybersecuritySearchResults}
    >
      {shouldRenderHeader && (
        <ListViewStickyHeader>
          <NoWrapListViewHeaderRow>
            <ListViewHeaderIconSpacer aria-hidden="true" />
            <NoWrapListViewHeaderCell flex="2 1 320px">
              {t("company")}
            </NoWrapListViewHeaderCell>
            <NoWrapListViewHeaderCell flex="1 1 160px">
              {t("region")}
            </NoWrapListViewHeaderCell>
            <NoWrapListViewHeaderCell flex="0.8 1 120px">
              {t("founded")}
            </NoWrapListViewHeaderCell>
            <NoWrapListViewHeaderCell flex="1 1 160px">
              {t("size")}
            </NoWrapListViewHeaderCell>
            <NoWrapListViewHeaderCell flex="1 1 220px">
              {t("website")}
            </NoWrapListViewHeaderCell>
          </NoWrapListViewHeaderRow>
        </ListViewStickyHeader>
      )}
      {cybersecurity_dataset?.map((mapObject: CyberSecurityListItem) => (
        <CybersecuritySearchResultItem
          key={mapObject.edrpou}
          mapObject={mapObject}
        />
      ))}
    </SearchResultsResponsive>
  );
};

export default CybersecurityMapSearchResults;

const NoWrapListViewHeaderRow = styled(ListViewHeaderRow)`
  flex-wrap: nowrap;
`;

const NoWrapListViewHeaderCell = styled(ListViewHeaderCell)`
  min-width: 0;
`;
